import type { IncidentType } from '@/types';

const isIncidentMatchedByRoutes = (
  incident: IncidentType,
  selectedLineNumbers: Set<string>
): boolean =>
  incident.affectedRoutes?.some((lineNumber) => selectedLineNumbers.has(lineNumber)) ?? false;

export default isIncidentMatchedByRoutes;
